import React from 'react'
import styled from 'styled-components'

import { AUTH_MODAL_SPLASH_VIDEO_URL } from '../constants/config'
import { ModalBackdropScrim, ModalBackdropVideo } from '../components/auth-modal/auth-modal.styled'

const PageBackdropVideo = styled(ModalBackdropVideo)`
  position: absolute;
  inset: 0;
`

const PageBackdropScrim = styled(ModalBackdropScrim)`
  position: absolute;
  inset: 0;
`

export default function AuthPageBackdropMedia () {
  return (
    <>
      <PageBackdropVideo
        src={AUTH_MODAL_SPLASH_VIDEO_URL}
        autoPlay
        muted
        loop
        playsInline
        aria-hidden
      />
      <PageBackdropScrim aria-hidden />
    </>
  )
}
